export const MARKETPLACE_TITLE_MAX_LENGTH = 80
export const MARKETPLACE_OTHER_CATEGORY_VALUE = '__outras_categorias__'
export const MARKETPLACE_OTHER_CATEGORY_LABEL = 'Outras categorias'
export const MARKETPLACE_LISTING_EDITOR_QUERY_PARAM = 'editar'

export const marketplaceListingEditorIdFromSearch = (search: string) => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const editorId = Number.parseInt(params.get(MARKETPLACE_LISTING_EDITOR_QUERY_PARAM) ?? '', 10)
  return Number.isFinite(editorId) && editorId > 0 ? Math.trunc(editorId) : null
}

export const marketplaceListingEditorSearch = (search: string, listingId?: number | null) => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  if (listingId && Number.isFinite(listingId) && listingId > 0) {
    params.set(MARKETPLACE_LISTING_EDITOR_QUERY_PARAM, String(Math.trunc(listingId)))
  } else {
    params.delete(MARKETPLACE_LISTING_EDITOR_QUERY_PARAM)
  }
  const serialized = params.toString()
  return serialized ? `?${serialized}` : ''
}

export const marketplaceListingEditorPath = (
  listingsPath: string,
  listingId?: number | null,
) => {
  const normalizedListingsPath = listingsPath.replace(/\/+$/, '') || '/'
  if (!listingId || !Number.isSafeInteger(listingId) || listingId <= 0) {
    return normalizedListingsPath
  }

  return `${normalizedListingsPath}/${listingId}/editar`
}

export const marketplaceListingEditorIdFromPath = (
  pathname: string,
  listingsPath: string,
) => {
  const normalizedListingsPath = listingsPath.replace(/\/+$/, '') || '/'
  const normalizedPathname = pathname.replace(/\/+$/, '') || '/'
  const editorPathPrefix = `${normalizedListingsPath}/`

  if (!normalizedPathname.startsWith(editorPathPrefix)) return null

  const [rawListingId, action, ...remainingSegments] = normalizedPathname
    .slice(editorPathPrefix.length)
    .split('/')

  if (action !== 'editar' || remainingSegments.length || !/^\d+$/.test(rawListingId)) return null

  const listingId = Number(rawListingId)
  return Number.isSafeInteger(listingId) && listingId > 0 ? listingId : null
}

export const resolveMarketplaceListingCode = (input: {
  listingCode?: string | null
  variationsEnabled: boolean
  variationCodes?: Array<string | null | undefined>
}) => {
  const listingCode = input.listingCode?.trim() || ''
  if (!input.variationsEnabled || listingCode) return listingCode
  return input.variationCodes?.find((code) => code?.trim())?.trim() || ''
}

export const hasMarketplaceCategory = (input: {
  produtoGrupoId?: number | null
  categoria?: string | null
}) => Boolean(input.produtoGrupoId || input.categoria?.trim())

export const marketplaceCategorySelectValue = (input: {
  produtoGrupoId?: number | null
  categoria?: string | null
}) => input.produtoGrupoId
  ? String(input.produtoGrupoId)
  : input.categoria?.trim()
    ? MARKETPLACE_OTHER_CATEGORY_VALUE
    : ''

export const marketplaceCategorySelectionPatch = (
  value: string,
  currentCategory?: string | null,
) => {
  if (value === MARKETPLACE_OTHER_CATEGORY_VALUE) {
    return {
      produtoGrupoId: null,
      categoria: currentCategory?.trim() || MARKETPLACE_OTHER_CATEGORY_LABEL,
    }
  }
  const productGroupId = Number(value)
  return {
    produtoGrupoId: Number.isFinite(productGroupId) && productGroupId > 0
      ? Math.trunc(productGroupId)
      : null,
    categoria: null,
  }
}
